{
  "popupAnimationDuration": "250"
}
